export const LAYOUTS = {
  main: {
    name: 'main',
    slots: {
      header: 'header',
      content: 'content'
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/layouts/index.js